<!--样式引入-->
<style scoped lang="scss" src="./index.scss"></style>

<!--模版引入-->
<template lang="pug" src="./index.pug"></template>

<script>
import { mapState } from "vuex";
export default {
  components: {},
  data() {
    return {
      userForm: {
        realName:null,
        avatar: null,
        hospital: null,
        room: null,    //科室
        competent: [],
        description:null,
      },
    };
  },
  computed: {
    ...mapState(['userInfo','authToken'])
  },
  watch: {
    
  },
  created: function() {
  },
  mounted: function() {
    const {realName,avatar,hospital,competent,description,room} = this.userInfo;
    this.userForm = {realName,avatar,hospital,competent,description,room};
  },
  methods: {
    addComp(index){
      if(this.userForm.competent.length>9){
        this.$toast('职务最多添加10个');
        return false;
      }
      this.userForm.competent.splice(index+1,0,'');
    },
    delComp(index){
      this.userForm.competent.splice(index,1);
    },
    //上传头像
    afterReadAvatar(e){
      this.$toast.loading({
        message: "上传中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      this.$api.upload({file:e.file}).then(res=>{
        this.userForm.avatar = res.data;
        this.$toast('上传成功');
      })
    },
    //格式校验
    beforeReadImages(file){
      if (['image/jpeg','image/png','image/gif'].indexOf(file.type) === -1) {
        this.$toast('图片格式错误');
        return false;
      }else{
        return true;
      }
    },
    //提交数据
    onSub(){
      var fd = this.$glf.parseObj(this.userForm);
      if(this.$glf.isEmpty(fd.realName)){
        this.$toast('请输入姓名');
        return false;
      }
      if(fd.realName.length>30){
        this.$toast('姓名最多30个字符');
        return false;
      }
      if(this.$glf.isEmpty(fd.avatar)){
        this.$toast('请上传头像');
        return false;
      }
      this.$toast.loading({
        message: "处理中...",
        forbidClick: true,
        loadingType: "spinner",
        duration: 0,
      });
      fd.competent = JSON.stringify(this.$glf.rmEmpty(fd.competent));
      this.$api.loginUserEdit(fd).then(res=>{
        this.$store.dispatch('refreshUser');
        this.$toast('保存成功');
      })
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/pages/mine/me/index.vue